import { PAGE_TYPE_CATEGORY } from 'shared/consts'
import {
  CAT_ADD_TO_CART_CLICK,
  CAT_REMOVE_CTA_AND_VARIANTS,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import trackEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'

const isEnvValid = (): boolean => {
  const { isEnabled } = getExperimentOnClient(CAT_REMOVE_CTA_AND_VARIANTS)
  const { pageType } = store.getPublicRuntimeConfig()?.pageProperties || {}

  return Boolean(isEnabled && pageType === PAGE_TYPE_CATEGORY)
}

export default () => {
  if (!isEnvValid()) {
    return
  }

  void activateExperiment(CAT_REMOVE_CTA_AND_VARIANTS)

  const container = document.querySelector(
    '[data-clientside-hook~="algoliaSearchListContainer"]'
  )
  container?.addEventListener('click', element => {
    const target = <HTMLElement>element.target

    if (
      target.closest('[data-clientside-hook~="add2CartForm"] [type=submit]')
    ) {
      trackEvent(CAT_ADD_TO_CART_CLICK)
    }
  })
}
